import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { 
  ShoppingCart, 
  Package, 
  Users, 
  FileText, 
  BarChart3, 
  Shield,
  Smartphone,
  Wifi,
  WifiOff,
  Clock,
  Star,
  CheckCircle,
  ArrowLeft,
  Play,
  MessageCircle,
  Gift,
  Zap,
  Heart,
  MapPin,
  Phone,
  Mail,
  Sparkles
} from 'lucide-react';

export default function LandingPage({ onGetStarted }) {
  const [showVideo, setShowVideo] = useState(false);

  const features = [
    { icon: ShoppingCart, title: 'نقطة البيع', desc: 'بيع سريع مع طباعة الفواتير' },
    { icon: Package, title: 'إدارة المخزون', desc: 'تتبع المنتجات والكميات' },
    { icon: Users, title: 'إدارة العملاء', desc: 'سجل العملاء والديون' },
    { icon: FileText, title: 'الفواتير', desc: 'فواتير احترافية قابلة للطباعة' },
    { icon: BarChart3, title: 'التقارير', desc: 'تقارير مفصلة للأرباح والمبيعات' },
    { icon: Shield, title: 'الأمان', desc: 'حماية بياناتك بتشفير متقدم' },
  ];

  const benefits = [
    { icon: Smartphone, text: 'يعمل على الهاتف والكمبيوتر' },
    { icon: WifiOff, text: 'يعمل بدون إنترنت' },
    { icon: Clock, text: 'توفير الوقت والجهد' },
    { icon: Zap, text: 'سرعة فائقة في الأداء' },
  ];

  const testimonials = [
    {
      name: 'أحمد محمد',
      business: 'سوبرماركت النور',
      text: 'تطبيق رائع! سهّل علي إدارة محلي بشكل كبير. أنصح به الجميع.',
      rating: 5
    },
    {
      name: 'فاطمة علي',
      business: 'صيدلية الشفاء',
      text: 'أفضل تطبيق محاسبة استخدمته. الدعم الفني ممتاز والتطبيق سهل جداً.',
      rating: 5
    },
    {
      name: 'محمد حسين',
      business: 'محل ملابس الأناقة',
      text: 'من أفضل القرارات اللي اتخذتها لمحلي. التقارير مفصلة ودقيقة.',
      rating: 5
    }
  ];

  // لا حاجة لرقم واتساب - التواصل عبر طلب التفعيل
  const whatsappLink = null;

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900" dir="rtl">
      
      {/* من نحن Section - في الأعلى */}
      <section className="relative overflow-hidden bg-gradient-to-br from-emerald-900/30 via-slate-900 to-teal-900/30 border-b border-emerald-500/20">
        <div className="absolute inset-0">
          <div className="absolute top-10 right-10 w-64 h-64 bg-emerald-500/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 left-10 w-64 h-64 bg-teal-500/10 rounded-full blur-3xl"></div>
        </div>
        
        <div className="container mx-auto px-4 py-12 md:py-16 relative z-10">
          <div className="max-w-4xl mx-auto">
            {/* العنوان */}
            <div className="text-center mb-8">
              {/* اللوغو */}
              <div className="inline-flex items-center justify-center w-28 h-28 mb-4">
                <img 
                  src="/nazario-logo.png" 
                  alt="فريق نازاريو" 
                  className="w-full h-full object-contain drop-shadow-lg"
                />
              </div>
              <div className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full px-4 py-2 mb-4">
                <Sparkles className="w-4 h-4 text-emerald-400" />
                <span className="text-emerald-400 text-sm font-medium">من نحن</span>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">
                تم تطويره بواسطة{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400">
                  فريق نازاريو
                </span>
              </h2>
              <p className="text-slate-400 text-lg max-w-2xl mx-auto">
                نظام متكامل لإدارة المحلات التجارية، صُمم خصيصاً لتلبية احتياجات السوق العراقي
              </p>
            </div>

            {/* بطاقات المعلومات */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* الموقع */}
              <Card className="bg-slate-800/50 border-slate-700 hover:border-emerald-500/50 transition-all">
                <CardContent className="p-5 text-center">
                  <div className="w-12 h-12 bg-emerald-500/20 rounded-xl flex items-center justify-center mx-auto mb-3">
                    <MapPin className="w-6 h-6 text-emerald-400" />
                  </div>
                  <p className="text-slate-400 text-sm mb-1">الموقع</p>
                  <p className="text-white font-medium">قرية بارا تحتاني - العراق</p>
                </CardContent>
              </Card>

              {/* التواصل */}
              <Card className="bg-slate-800/50 border-slate-700 hover:border-emerald-500/50 transition-all">
                <CardContent className="p-5 text-center">
                  <div className="w-12 h-12 bg-green-500/20 rounded-xl flex items-center justify-center mx-auto mb-3">
                    <Phone className="w-6 h-6 text-green-400" />
                  </div>
                  <p className="text-slate-400 text-sm mb-1">للتواصل والاستفسار</p>
                  <div className="space-y-1">
                    <a href="https://wa.me/9647772719901" target="_blank" rel="noopener noreferrer" 
                       className="block text-white font-mono hover:text-emerald-400 transition-colors" dir="ltr">
                      07772719901
                    </a>
                    <a href="https://wa.me/9647507940933" target="_blank" rel="noopener noreferrer" 
                       className="block text-white font-mono hover:text-emerald-400 transition-colors" dir="ltr">
                      07507940933
                    </a>
                  </div>
                </CardContent>
              </Card>

              {/* البريد */}
              <Card className="bg-slate-800/50 border-slate-700 hover:border-emerald-500/50 transition-all">
                <CardContent className="p-5 text-center">
                  <div className="w-12 h-12 bg-blue-500/20 rounded-xl flex items-center justify-center mx-auto mb-3">
                    <Mail className="w-6 h-6 text-blue-400" />
                  </div>
                  <p className="text-slate-400 text-sm mb-1">البريد الإلكتروني</p>
                  <a href="mailto:aomerali42hesabaty@gmail.com" 
                     className="text-white text-sm font-mono hover:text-emerald-400 transition-colors break-all" dir="ltr">
                    aomerali42hesabaty@gmail.com
                  </a>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* Hero Section */}
      <section className="relative overflow-hidden">
        {/* Background Effects */}
        <div className="absolute inset-0 bg-[url('data:image/svg+xml,...')] opacity-5"></div>
        <div className="absolute top-20 right-10 w-72 h-72 bg-emerald-500/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-10 w-72 h-72 bg-blue-500/20 rounded-full blur-3xl"></div>
        
        <div className="container mx-auto px-4 py-16 md:py-24 relative z-10">
          <div className="text-center max-w-4xl mx-auto">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full px-4 py-2 mb-6">
              <Gift className="w-4 h-4 text-emerald-400" />
              <span className="text-emerald-400 text-sm font-medium">تجربة مجانية 5 أيام</span>
            </div>
            
            {/* Title */}
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
              أدِر محلك بـ
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400"> ذكاء </span>
              وسهولة
            </h1>
            
            {/* Subtitle */}
            <p className="text-xl text-slate-300 mb-8 max-w-2xl mx-auto">
              نظام محاسبة وإدارة مخزون متكامل لمحلك التجاري. 
              سهل الاستخدام، يعمل بدون إنترنت، ومصمم للمحلات التجارية.
            </p>
            
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Button 
                onClick={onGetStarted}
                className="bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-600 hover:to-teal-600 text-white px-8 py-6 text-lg rounded-xl shadow-lg shadow-emerald-500/25"
                data-testid="get-started-btn"
              >
                <Gift className="w-5 h-5 me-2" />
                ابدأ تجربتك المجانية
              </Button>
              
              <Link to="/support">
                <Button 
                  variant="outline" 
                  className="border-slate-600 text-slate-300 hover:bg-slate-800 px-8 py-6 text-lg rounded-xl"
                >
                  <MessageCircle className="w-5 h-5 me-2 text-emerald-500" />
                  الدعم الفني
                </Button>
              </Link>
            </div>

            {/* Trust Indicators */}
            <div className="flex flex-wrap justify-center gap-6 mt-10 text-slate-400">
              <div className="flex items-center gap-2">
                <CheckCircle className="w-5 h-5 text-emerald-500" />
                <span>بدون بطاقة ائتمان</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle className="w-5 h-5 text-emerald-500" />
                <span>إلغاء في أي وقت</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle className="w-5 h-5 text-emerald-500" />
                <span>دعم فني عبر التطبيق</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Bar */}
      <section className="bg-slate-800/50 border-y border-slate-700">
        <div className="container mx-auto px-4 py-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-center justify-center gap-3 text-slate-300">
                <benefit.icon className="w-5 h-5 text-emerald-400" />
                <span className="text-sm md:text-base">{benefit.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              كل ما تحتاجه في تطبيق واحد
            </h2>
            <p className="text-slate-400 text-lg max-w-2xl mx-auto">
              أدوات متكاملة لإدارة محلك التجاري بكفاءة واحترافية
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature, index) => (
              <Card key={index} className="bg-slate-800/50 border-slate-700 hover:border-emerald-500/50 transition-all duration-300 hover:-translate-y-1">
                <CardContent className="p-6">
                  <div className="w-12 h-12 bg-emerald-500/10 rounded-xl flex items-center justify-center mb-4">
                    <feature.icon className="w-6 h-6 text-emerald-400" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
                  <p className="text-slate-400">{feature.desc}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-16 md:py-24 bg-slate-800/30">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              ماذا يقول عملاؤنا؟
            </h2>
            <p className="text-slate-400 text-lg">
              آراء حقيقية من أصحاب المحلات
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {testimonials.map((testimonial, index) => (
              <Card key={index} className="bg-slate-800/50 border-slate-700">
                <CardContent className="p-6">
                  {/* Stars */}
                  <div className="flex gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" />
                    ))}
                  </div>
                  
                  {/* Quote */}
                  <p className="text-slate-300 mb-4 leading-relaxed">
                    "{testimonial.text}"
                  </p>
                  
                  {/* Author */}
                  <div className="border-t border-slate-700 pt-4">
                    <p className="font-bold text-white">{testimonial.name}</p>
                    <p className="text-sm text-slate-400">{testimonial.business}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              السعر الموحد
            </h2>
            <p className="text-slate-400 text-lg">تطبيق كامل بسعر واحد - جميع الميزات متاحة</p>
          </div>
          
          <div className="max-w-xl mx-auto">
            {/* الباقة الموحدة */}
            <Card className="bg-gradient-to-br from-emerald-500/10 to-teal-500/10 border-emerald-500/30 overflow-hidden relative">
              <div className="absolute top-4 left-4 bg-emerald-500 text-white text-xs px-3 py-1 rounded-full font-bold">
                جميع الميزات
              </div>
              <div className="bg-gradient-to-r from-emerald-500 to-teal-500 py-4 text-center">
                <span className="text-white font-bold text-xl">التطبيق الكامل</span>
              </div>
              <CardContent className="p-6">
                {/* السعر */}
                <div className="text-center p-6 bg-slate-800/50 rounded-xl mb-6">
                  <p className="text-sm text-slate-400 mb-2">دفعة واحدة فقط</p>
                  <p className="text-4xl font-bold text-emerald-400">690,000</p>
                  <p className="text-slate-500 mt-1">دينار عراقي</p>
                </div>
                
                {/* طرق الدفع */}
                <div className="bg-slate-800/30 rounded-xl p-4 mb-6">
                  <p className="text-center text-slate-400 text-sm mb-3">طريقة الدفع:</p>
                  <div className="flex justify-center">
                    <div className="text-center bg-emerald-900/30 px-6 py-3 rounded-lg border border-emerald-500/30">
                      <p className="text-emerald-400 text-lg">تواصل مع الدعم الفني</p>
                      <p className="text-white text-sm">للحصول على تفاصيل الدفع</p>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-3 mb-6 text-sm">
                  <div className="flex items-center gap-2 text-slate-300">
                    <CheckCircle className="w-4 h-4 text-emerald-500 flex-shrink-0" />
                    <span>نقطة البيع</span>
                  </div>
                  <div className="flex items-center gap-2 text-slate-300">
                    <CheckCircle className="w-4 h-4 text-emerald-500 flex-shrink-0" />
                    <span>إدارة المخزون</span>
                  </div>
                  <div className="flex items-center gap-2 text-slate-300">
                    <CheckCircle className="w-4 h-4 text-emerald-500 flex-shrink-0" />
                    <span>الزبائن والموردين</span>
                  </div>
                  <div className="flex items-center gap-2 text-slate-300">
                    <CheckCircle className="w-4 h-4 text-emerald-500 flex-shrink-0" />
                    <span>التقارير المتقدمة</span>
                  </div>
                  <div className="flex items-center gap-2 text-slate-300">
                    <CheckCircle className="w-4 h-4 text-emerald-500 flex-shrink-0" />
                    <span>إدارة الديون</span>
                  </div>
                  <div className="flex items-center gap-2 text-slate-300">
                    <CheckCircle className="w-4 h-4 text-emerald-500 flex-shrink-0" />
                    <span>البيع بالتقسيط</span>
                  </div>
                  <div className="flex items-center gap-2 text-slate-300">
                    <CheckCircle className="w-4 h-4 text-emerald-500 flex-shrink-0" />
                    <span>العقود الذكية (AI)</span>
                  </div>
                  <div className="flex items-center gap-2 text-slate-300">
                    <CheckCircle className="w-4 h-4 text-emerald-500 flex-shrink-0" />
                    <span>النسخ الاحتياطي</span>
                  </div>
                </div>
                
                <Button 
                  onClick={onGetStarted}
                  className="w-full bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-600 hover:to-teal-600 text-white py-4 rounded-xl text-lg"
                >
                  <Gift className="w-5 h-5 me-2" />
                  ابدأ تجربة 5 أيام مجاناً
                </Button>
              </CardContent>
            </Card>
          </div>
          
          {/* ملاحظة */}
          <p className="text-center text-slate-500 mt-8 text-sm">
            * سجّل حسابك وأرسل طلب تفعيل للحصول على الفترة التجريبية
          </p>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-gradient-to-r from-emerald-600 to-teal-600">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            جاهز لتطوير عملك؟
          </h2>
          <p className="text-emerald-100 text-lg mb-8 max-w-2xl mx-auto">
            ابدأ تجربتك المجانية الآن واكتشف كيف يمكن لتطبيقنا مساعدتك
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              onClick={onGetStarted}
              className="bg-white text-emerald-600 hover:bg-emerald-50 px-8 py-6 text-lg rounded-xl font-bold"
            >
              <Gift className="w-5 h-5 me-2" />
              ابدأ تجربتك المجانية
            </Button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 border-t border-slate-800 py-8">
        <div className="container mx-auto px-4">
          <div className="text-center space-y-4">
            <p className="text-white font-bold text-lg">فريق نازاريو</p>
            <p className="text-slate-400">قرية بارا تحتاني - العراق</p>
            <div className="flex items-center justify-center gap-4 text-slate-400">
              <a href="https://wa.me/9647772719901" target="_blank" rel="noopener noreferrer" 
                 className="hover:text-emerald-400 transition-colors flex items-center gap-2">
                <Phone className="w-4 h-4" />
                <span dir="ltr">07772719901</span>
              </a>
              <span className="text-slate-600">|</span>
              <a href="https://wa.me/9647507940933" target="_blank" rel="noopener noreferrer" 
                 className="hover:text-emerald-400 transition-colors flex items-center gap-2">
                <Phone className="w-4 h-4" />
                <span dir="ltr">07507940933</span>
              </a>
            </div>
            <p className="text-slate-500 text-sm pt-4 border-t border-slate-800">
              تم بواسطة فريق نازاريو في قرية بارا تحتاني-العراق
              <br />
              © 2026 جميع الحقوق محفوظة
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
